<template>
  <AdminInformationDialog
    v-if="displayAdminInfos.length !== 0"
    :key="currentDisplayAdminInfo.id"
    :info="currentDisplayAdminInfo"
    @close="handleCloseAndOpenNextAdminInfo" />
</template>

<script>
import AdminInformationDialog from '@/components/view/AdminInformationDialog.vue'
import { mapState } from 'vuex'

// 5分ごとにお知らせを取得する
const INTERVAL_MINUTES = 3
const INTERVAL_MILLISECONDS = INTERVAL_MINUTES * 60 * 1000

export default {
  components: {
    AdminInformationDialog,
  },
  data() {
    return {
      currentInfoIndex: 0,
      displayAdminInfos: [],
      intervalId: null
    }
  },
  computed: {
    ...mapState('adminInformation', ['notDisplayAdminInfos']),
    currentDisplayAdminInfo() {
      if (this.displayAdminInfos.length === 0) {
        return null
      }
      return this.displayAdminInfos[this.currentInfoIndex]
    },
    hasNextDisplayAdminInfo() {
      return !!this.displayAdminInfos[this.currentInfoIndex + 1]
    },
    alreadyReadAdminInfoIds: {
      get() {
        return this.$store.state.adminInformation.alreadyReadAdminInfoIds
      },
      set(v) {
        this.$store.commit('adminInformation/setAlreadyReadAdminInfoIds', v)
      }
    },
    notDisplayAdminInfoIds() {
      return this.notDisplayAdminInfos.map(info => info.id)
    }
  },
  async created() {
    this.$store.dispatch('adminInformation/refreshNotDisplayAdminInfos')
    this.fetchAndDisplayAdminInfos()
    this.setInterval()
  },
  methods: {
    async fetchAdminInfos() {
      return this.$baseAxios.get('/managements/admin_information/').then(res => {
        return res.data.results
      }).catch((err) => {
        console.error(err)
      })
    },
    setAlreadyReadAdminInfos(adminInfos) {
      // 抜き出したお知らせのIDを保存する
      const newAdminInfoIds = adminInfos.map(info => info.id)
      this.alreadyReadAdminInfoIds = newAdminInfoIds
    },
    // 未読かつ表示するお知らせのみ表示する
    async fetchAndDisplayAdminInfos() {
      const adminInfos = await this.fetchAdminInfos()

      if (adminInfos.length === 0) return
      this.$store.dispatch('adminInformation/updateNotDisplayAdminInfos', adminInfos)

      const displayAdminInfos = adminInfos.filter(info => {
        return !this.alreadyReadAdminInfoIds.includes(info.id) && !this.notDisplayAdminInfoIds.includes(info.id)
      })
      if (displayAdminInfos.length === 0) return

      // お知らせ表示中は取得処理を停止する
      this.clearInterval()
      this.displayAdminInfos = displayAdminInfos
      this.$nextTick(() => {
        this.$bvModal.show('admin-information-dialog')
      })
      // リロードするまでお知らせを表示しないようにする
      this.setAlreadyReadAdminInfos(adminInfos)
    },
    setInterval() {
      this.intervalId = window.setInterval(() => {
        console.log('--- interval ---')
        this.fetchAndDisplayAdminInfos()
      }, INTERVAL_MILLISECONDS)
      console.log('----interval start', this.intervalId)
    },
    clearInterval() {
      window.clearInterval(this.intervalId)
      console.log('----interval cleared', this.intervalId)
    },
    handleCloseAndOpenNextAdminInfo(notDisplayInfo) {
      this.$bvModal.hide('admin-information-dialog')

      if (notDisplayInfo) {
        const infos = [
          ...this.notDisplayAdminInfos,
          {
            id: this.currentDisplayAdminInfo.id,
            endDatetime: this.currentDisplayAdminInfo.endDatetime
          }
        ]
        this.$store.commit('adminInformation/setNotDisplayAdminInfos', infos)
      }

      if (this.hasNextDisplayAdminInfo) {
        this.currentInfoIndex++
        this.$nextTick(() => {
          this.$bvModal.show('admin-information-dialog')
        })
        return
      }

      // 状態をリセットし、取得処理を再開
      this.currentInfoIndex = 0
      this.displayAdminInfos = []
      this.setInterval()
    }
  }
}
</script>

<style>

</style>